import { render } from "./Notification.vue?vue&type=template&id=88e4ce6e"
import script from "./Notification.vue?vue&type=script&lang=js"
export * from "./Notification.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\david\\Documents\\Dada\\Omnichannel-Dada\\dashboard-agente\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__